<div attr.tid="{{config.label}}" *ngIf="!config.isHidden">
    <div class="tml-tpl-label" *ngIf="!config.isLabelHidden">
        <label>{{config.label}}<span *ngIf="config.isRequired" style="color:red;">&nbsp;*</span></label>
    </div>
    <div class="tml-tpl-input" [style.width.px]="config.controlWidth">
        <kendo-multiselect #entitylist [data]="suggestionItems" [filterable]="true"
            [popupSettings]="{appendTo: 'component'}" (filterChange)="handleFilter($event)" [disabled]="readOnly"
            [textField]="'name'" [valueField]="'id'" [autoClose]="isAutoClose" [(ngModel)]="selectedItems"
            (valueChange)="valueChange($event)" (focus)="medOnFocus($event)" (keydown.esc)="onEnter($event)"
            (mousedown)="$event.preventDefault()" (open)="onOpen($event)">
            <div
                *ngIf="config.componentType == 'med-input' && config.controlID.indexOf('AddRelationshipEntity') === -1">
                <ng-template kendoMultiSelectHeaderTemplate>
                    <div class="popup-template-clear-header">
                        <span class="multiselect-Clear" (click)="clearValue()">Clear</span>
                    </div>
                </ng-template>
            </div>
            <div *ngIf="config.controlID.indexOf('AddRelationshipEntity') !== -1">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <tam-entity-dropdown-item [entity]="dataItem"></tam-entity-dropdown-item>
                </ng-template>
            </div>
            <div *ngIf="config.controlID.indexOf('JobTitle') !== -1">
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    <span>{{dataItem.name}}</span><span *ngIf="dataItem.id ==='searchId'" class='new-jobtitle-hint'>
                        (New
                        Job Title)</span>
                </ng-template>
            </div>

            <ng-template kendoMultiSelectNoDataTemplate>
                <div class="popup-template-no-data">
                    <div class="no-data"><span>NO DATA FOUND</span></div>
                    <div *ngIf="isFly && isShowCreateContact">
                        <span class="link" (click)="createContact()">Create Contact</span>
                    </div>
                    <div *ngIf="isFly && isShowCreateEntity">
                        <span class="link" (click)="createEntity()">Create Entity</span>
                    </div>
                    <div *ngIf="isFly && isShowCreateRelationship">
                        <span class="link" (click)="createValidRelationshipByRestApi()">Create Job Title</span>
                    </div>
                </div>
            </ng-template>
        </kendo-multiselect>
    </div>
    <label [hidden]="isMatchJobTitle" class="dis-row"> Relationship Type <span>{{hintContent}}</span> not
        found, please create or
        enter a new one
    </label>
</div>